import React from 'react';
import { View, TouchableOpacity, StyleSheet, ScrollView } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../../../styles';
import { scale } from '../../../utils/scale.utils';
import BaseText from '../../BaseText';
import Button, { BUTTON_TYPES } from '../../Button';
import Icon from '../../Icon';
import Modal from '../../Modal';
import RowView from '../../RowView';
import moment from 'moment';

const ItemContent = ({ iconName, children }) => {
  return (
    <RowView style={CommonStyles.my3}>
      <Icon
        name={iconName}
        size={28}
        color={Color.primary}
        style={[CommonStyles.mx4, CommonStyles.mt1]}
      />
      <View style={CommonStyles.flex1}>{children}</View>
    </RowView>
  );
};

const MeetingDetailsModal = ({ visible, meeting = {}, onClose, onSubmit, onDelete }) => {
  const date = meeting?.EventDate;
  return (
    <Modal visible={visible} transparent>
      <View style={stylesModal.wrap}>
        <View style={stylesModal.scroll}>
          <ScrollView>
            <View style={stylesModal.innerWrap}>
              <TouchableOpacity onPress={onClose} style={stylesModal.close}>
                <Icon name="cancel" color={Color.primary} size={18} />
              </TouchableOpacity>
              <BaseText style={stylesModal.title}>Meeting Details</BaseText>
              <ItemContent iconName="calendar Check">
                <BaseText style={CommonStyles.h2}>{meeting?.title}</BaseText>
                <BaseText style={CommonStyles.h3}>
                  {date ? moment(date).format('MMM DD') : ''}
                </BaseText>
                <BaseText style={CommonStyles.h3}>
                  {date ? moment(date).format('hh mm a') : ''}
                </BaseText>
              </ItemContent>
              <ItemContent iconName="link">
                <BaseText style={CommonStyles.h3}>
                  There is a virtual link for this meeting
                </BaseText>
              </ItemContent>
              <ItemContent iconName="mark">
                <BaseText style={CommonStyles.h3}>Fountain Bistro</BaseText>
                <BaseText style={{ color: Color.primary, ...CommonProperties.h4 }}>
                  {meeting?.address?.displaylabel}
                </BaseText>
              </ItemContent>
              <ItemContent iconName="message">
                <BaseText style={CommonStyles.h4}>{meeting?.description}</BaseText>
              </ItemContent>
              {/* <BaseText
                style={{
                  ...CommonProperties.h1,
                  textAlign: 'center',
                  ...CommonProperties.mt5,
                  ...CommonProperties.py4,
                }}
              >
                Speaker Details
              </BaseText> */}
              <View style={{ alignItems: 'center' }}>
                {/* <Avatar
                  source={{ uri: 'https://randomuser.me/api/portraits/men/1.jpg' }}
                  size={120}
                />
                <BaseText style={CommonStyles.h2}>Luis Gomez</BaseText>
                <BaseText
                  style={{ ...CommonProperties.h3, color: Color.grayText, ...CommonProperties.mb4 }}
                >
                  Policy & Principals of a Sales Leader
                </BaseText>
                <BaseText style={CommonStyles.h4}>
                  Best selling author of 9 title including: "You, Me & Sales", "I Pay you Win", and
                  many more. 10 Time Sales Champion for Detroit SalesForce
                </BaseText> */}
                <Button
                  label="Delete Meeting"
                  type={BUTTON_TYPES.OUTLINED}
                  style={stylesModal.submit}
                  labelStyle={CommonStyles.h2}
                  onPress={onDelete}
                />
                <Button
                  label="Edit Meeting"
                  style={stylesModal.submit}
                  labelStyle={CommonStyles.h2}
                  onPress={() => onSubmit()}
                />
              </View>
            </View>
          </ScrollView>
        </View>
      </View>
    </Modal>
  );
};

const stylesModal = StyleSheet.create({
  wrap: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,.5)',
    ...CommonProperties.p3,
    ...CommonProperties.centerAlignment,
  },
  scroll: {
    //flex: 1,
    width: '100%',
  },
  innerWrap: {
    backgroundColor: 'white',
    ...CommonProperties.p4,
    ...CommonProperties.borderRadius2,
  },
  title: {
    textAlign: 'center',
    ...CommonProperties.h1,
    ...CommonProperties.mb3,
  },
  item: {
    flex: 1,
    alignItems: 'center',
    ...CommonProperties.mb3,
  },
  close: {
    position: 'absolute',
    top: scale(14),
    right: scale(12),
  },
  new: {
    ...CommonProperties.h3,
    ...CommonProperties.ml3,
  },
  submit: {
    maxWidth: scale(240),
    width: '100%',
    ...CommonProperties.mt5,
    ...CommonProperties.borderRadius4,
    ...CommonProperties.py3,
  },
});

export default MeetingDetailsModal;
